import React, {useState} from 'react';
import {StyleSheet} from 'react-native';
import WebView from 'react-native-webview';
import {useFocusEffect} from '@react-navigation/native';
import {observer} from 'mobx-react';

import ActivityIndicator from '../../components/ui-controls/ActivityIndicator';
import ContentView from '../../components/ui-controls/layout/ContentView';
import {useWebScreenDimensions} from '../../hooks/useWebScreenDimensions';
import {AppRoute} from '../../models/AppRoute';
import {RootStackScreenProps} from '../../models/navigationTypes';
import {useStores} from '../../stores/use-stores';
import apiService from '../../transport/apiService';

const SummerCashGrabScreen = observer(
  ({route}: RootStackScreenProps<AppRoute.SUMMER_CASH_GRAB_GAME>) => {
    const iFrameLinkParams = route.params.iFrameLinkParams || '';

    const [gameConfig, setGameConfig] = useState<{
      initScript: string;
      gameUri: string;
      htmlContent: string;
    } | null>(null);
    const {isWebDesktopScreen} = useWebScreenDimensions();

    const {
      shopSelectionStore: {selectedStore},
    } = useStores();

    const storeState =
      selectedStore?.address?.administrative_area?.toUpperCase() || '';

    let finalIframeLinkParams = iFrameLinkParams
      ? `${iFrameLinkParams}&state=${storeState}`
      : '';

    useFocusEffect(
      React.useCallback(() => {
        async function fetchData() {
          const config = await apiService.getSummerCashGrabHtml(
            finalIframeLinkParams,
          );
          setGameConfig(config);
        }
        fetchData();
      }, [finalIframeLinkParams]),
    );

    const platformStyles = StyleSheet.create({
      main: {
        ...(isWebDesktopScreen
          ? {}
          : {
              paddingBottom: 0,
              paddingTop: 0,
              paddingLeft: 0,
              paddingRight: 0,
            }),
      },
      parent: {
        paddingBottom: 0,
        paddingTop: 0,
        paddingLeft: 0,
        paddingRight: 0,
      },
    });

    return (
      <ContentView
        testID="summer-cash-grab-screen"
        style={platformStyles.main}
        parentStyle={platformStyles.parent}>
        {gameConfig ? renderGame(gameConfig) : <ActivityIndicator />}
      </ContentView>
    );
  },
);

const renderGame = ({
  htmlContent,
}: {
  initScript: string;
  gameUri: string;
  htmlContent: string;
}) => (
  <WebView
    id="summer-cash-grab-game-webview"
    testID="summer-cash-grab-game-webview"
    javaScriptEnabled={true}
    cacheEnabled={false}
    startInLoadingState
    source={{
      html: htmlContent,
    }}
    style={styles.webview}
  />
);

export default SummerCashGrabScreen;

const styles = StyleSheet.create({
  webview: {
    flex: 1,
    height: '100%',
    width: '100%',
  },
});
